import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { urlHasHashParam } from "drh-js-library/dist/drh-url-utils/url-has-hash-param";
import { DrhUrlParams } from "../../../system/constants/url/drh-url-params";
import { LocationZoomSettings } from "../../models/map-settings";

import { getHashQueryStringParam } from "../../../system/functions/url/get-hash-query-string-param";
export const getLocationFromUrl = (url: string): LocationZoomSettings => {
	if (isStringEmpty(url)) {
		return null;
	}

	let theUrl = new URL(url);

	var latitude = parseFloat(
		getHashQueryStringParam(DrhUrlParams.Latitude.paramName, theUrl.hash),
	);

	var longitude = parseFloat(
		getHashQueryStringParam(DrhUrlParams.Longitude.paramName, theUrl.hash),
	);

	var radius = parseInt(
		getHashQueryStringParam(DrhUrlParams.Radius.paramName, theUrl.hash),
	);
	var zoom = parseInt(
		getHashQueryStringParam(DrhUrlParams.Zoom.paramName, theUrl.hash),
	);
	return {
		lat: latitude as number,
		lng: longitude as number,
		zoom: zoom as number,
		radius: radius as number,
	} as LocationZoomSettings;
};
